import React from 'react'
import './Services.css';
import logo from './images/yemi1.png';
import web from './images/web.png';
import csc from './images/csc.png';
import proj from './images/student projetcs.jpg';
import mba from './images/mob.png';
import twod from './images/2d.jpg';
import db from './images/db.jpg';

function Services() {
    return (
        <div className="services">
            <div class="video1">
                {/* <h3 style={{textAlign: "center" }}>Services</h3> */}
            </div>
            <div className="row">
                <div className="col-md-4"><br />
                    <div class="box" id="box1">
                        <div class="box3">
                            <div>
                                <button class="btns">View Details</button>
                            </div>
                        </div>
                        <div class="innerbox">
                            <div class="logo1"><img src={logo} alt="" /><span class="name1">computer</span><span
                                    class="name11">Science Courses</span></div>
                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                            <div class="mainimg"><img src={csc} alt="" /> </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-4"><br/>
                    <div class="box" id="box12">
                        <div class="box3">
                            <div>
                                <button class="btns">View Details</button>
                            </div>
                        </div>
                        <div class="innerbox">
                            <div class="logo1"><img src={logo} alt="" /><span class="name1">Mobile App</span><span
                                    class="name11">Development</span></div>
                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                            <div class="mainimg"><img src={mba} alt="" /> </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-4"><br />
                    <div class="box" id="box13">
                        <div class="box3">
                            <div>
                                <button class="btns">View Details</button>
                            </div>
                        </div>
                        <div class="innerbox">
                            <div class="logo1"><img src={logo} alt="" /><span class="name1">Web</span><span
                                    class="name11">Design & Development</span></div>
                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                            <div class="mainimg"><img src={web} alt="" /> </div>
                        </div>
                    </div>
                </div>                                   
            </div>

            <br/>
            <div className="row">
                <div className="col-md-4"><br />
                    <div class="box" id="box1">
                        <div class="box3">
                            <div>
                                <button class="btns">View Details</button>
                            </div>
                        </div>
                        <div class="innerbox">
                            <div class="logo1"><img src={logo} alt="" /><span class="name1">2D Game</span><span
                                    class="name11">Development</span></div>
                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                            <div class="mainimg"><img src={twod} alt="" /> </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-4"><br />
                    <div class="box" id="box12">
                        <div class="box3">
                            <div>
                                <button class="btns">View Details</button>
                            </div>
                        </div>
                        <div class="innerbox">
                            <div class="logo1"><img src={logo} alt="" /><span class="name1">Database</span><span
                                    class="name11">Design & Development</span></div>
                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                            <div class="mainimg"><img src={db} alt="" /> </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-4"><br />
                    <div class="box" id="box13">
                        <div class="box3">
                            <div>
                                <button class="btns">View Details</button>
                            </div>
                        </div>
                        <div class="innerbox">
                            <div class="logo1"><img src={logo} alt="" /><span class="name1">CS, CE, IT, CSE</span><span
                                    class="name11">Final Year Projects</span></div>
                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                            <div class="mainimg"><img src={proj} alt="" /> </div>
                        </div>
                    </div>
                </div>                                   
            </div>
        </div>
    )
}

export default Services
